// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__x_Bvz","title":"AfterFrontImage_title__2jezg"};